// pages/Careers/Careers.jsx
import { ArrowRight, Briefcase, Globe, HeartHandshake, Users } from "lucide-react";
import "../../index.css";
import "./Careers.css";

const Careers = () => {
  return (
    <>
      {/* Hero - bigger, bolder, more premium */}
      <section className="hero careers-hero">
        <div className="container">
          <div className="hero-content">
            <h1>
              Careers at <span className="highlight">DevLearn</span>
            </h1>
            <p className="hero-subtitle">
              Build Evidence. Strengthen Systems. Change Lives.
            </p>
            <p className="hero-lead">
              DevLearn Impact Research Ltd is a Zambian-owned research and advisory firm working at the intersection of evidence, systems, and social justice to improve development outcomes across Africa. Our work spans research, evaluation, implementation learning, data analytics, governance, and capacity development across sectors, including education, health, climate, gender, youth, and social protection. We seek curious, ethical, and driven professionals who want to use their skills to create meaningful, lasting impact.
            </p>

            <div className="hero-cta">
              <a
                href="https://forms.gle/Pa4m51o2FMvoA7yw8"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary premium"
              >
                Join Our Associate Network
                <ArrowRight size={24} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Who We're Looking For - elegant two-column */}
      <section className="section who-section">
        <div className="container narrow">
          <div className="section-header text-center">
            <h2>We Are Looking For</h2>
            <p className="section-lead">
              Curious minds. Ethical professionals. People driven to create real change.
            </p>
          </div>

          <div className="who-layout">
            <div className="who-text">
              <p>
                We welcome researchers, evaluators, data analysts, M&E specialists, gender & 
                inclusion experts, policy professionals, capacity builders and early-career 
                talent passionate about evidence-based development.
              </p>
              <p>
                If you want your work to matter, in education, health, climate resilience, 
                governance, youth empowerment, social protection and beyond, we want to meet you.
              </p>
            </div>

            <div className="who-icons">
              <div className="icon-card">
                <Briefcase size={36} />
                <span>Research & Evaluation</span>
              </div>
              <div className="icon-card">
                <Globe size={36} />
                <span>Policy & Systems</span>
              </div>
              <div className="icon-card">
                <HeartHandshake size={36} />
                <span>Equity & Inclusion</span>
              </div>
              <div className="icon-card">
                <Users size={36} />
                <span>Capacity Building</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Inclusion - standout pill section */}
      <section className="section inclusion-section">
        <div className="container narrow text-center">
          <h2>Our Commitment</h2>
          <p className="inclusion-text">
            DevLearn is proudly <strong>equal opportunity</strong>.<br />
            We actively encourage applications from:
          </p>

          <div className="inclusion-pills">
            <div className="pill">Women</div>
            <div className="pill">Young professionals</div>
            <div className="pill">Persons with disabilities</div>
            <div className="pill">Underrepresented groups</div>
          </div>
        </div>
      </section>

      {/* Apply Callout - premium card style */}
      <section className="section apply-section">
        <div className="container narrow">
          <div className="apply-card">
            <div className="apply-header">
              <h2>Join Our Associate Consultant Network</h2>
              <p className="apply-subtitle">
                Work with us on impactful research, evaluations, training, advisory, 
                and capacity development assignments across the region.
              </p>
            </div>

            <div className="apply-body">
              <h3>How to Apply</h3>
              <p>
                Submit your CV and a short statement of interest (max 300 words) 
                via our simple online form.
              </p>

              <a
                href="https://forms.gle/Pa4m51o2FMvoA7yw8"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary premium large"
              >
                Submit Your Interest Now
                <ArrowRight size={24} />
              </a>

              <p className="note">
                We review applications on a rolling basis and will reach out when 
                opportunities match your profile and expertise.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta">
        <div className="container narrow text-center">
          <h2>Ready to make a difference?</h2>
          <p>We’re excited to discover how your skills and passion can help us drive change.</p>

          <a
            href="https://forms.gle/Pa4m51o2FMvoA7yw8"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary premium large"
          >
            Apply Today
            <ArrowRight size={28} />
          </a>
        </div>
      </section>

      {/* Footer - same as team page but with careers link */}
      <footer className="footer">
        <div className="footer-grid container">
          <div>
            <div className="footer-logo">DevLearn Impact Research Ltd</div>
            <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
            <p>+260 973 902 981 / +260 978 341 825</p>
            <p>info@devlearnimpact.com</p>
          </div>
          <div>
            <h4>Services</h4>
            <ul>
              <li><a href="/services">Applied Research</a></li>
              <li><a href="/services">MERL Frameworks</a></li>
              <li><a href="/services">Capacity Building</a></li>
            </ul>
          </div>
          <div>
            <h4>Thematic Areas</h4>
            <ul>
              <li><a href="/sectors">Education & Health</a></li>
              <li><a href="/sectors">Governance & Climate</a></li>
              <li><a href="/sectors">Economic Inclusion</a></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/team">Team</a></li>
              <li><a href="/careers">Careers</a></li>
              <li><a href="/case-studies">Projects</a></li>
            </ul>
          </div>
          <div>
            <h4>Connect</h4>
            <ul>
              <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
              <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          © 2026 DevLearn Impact Research Ltd. All rights reserved.
        </div>
      </footer>
    </>
  );
};

export default Careers;

// // pages/Careers/Careers.jsx
// import { ArrowRight, Users, HeartHandshake, Briefcase, Globe } from "lucide-react";
// import "../../index.css"; // global styles
// import "./Careers.css"; // page-specific styles

// const Careers = () => {
//   return (
//     <>
//       {/* Hero */}
//       <section className="hero careers-hero">
//         <div className="container text-center">
//           <h1>Careers at DevLearn</h1>
//           <p className="hero-subtitle">
//             Build Evidence. Strengthen Systems. Change Lives.
//           </p>

//           <div className="hero-lead">
//             We are a Zambian-owned research and advisory firm working at the intersection of 
//             <strong> evidence</strong>, <strong>systems</strong>, and <strong>social justice</strong> 
//             to improve development outcomes across Africa.
//           </div>

//           <div className="hero-buttons">
//             <a
//               href="https://forms.gle/Pa4m51o2FMvoA7yw8"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="btn btn-primary large"
//             >
//               Apply to Join Our Network <ArrowRight size={24} />
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Mission & Who We Look For */}
//       <section className="section mission-section">
//         <div className="container">
//           <div className="two-column-layout">
//             <div className="mission-text">
//               <h2>Who We Are Looking For</h2>
//               <p>
//                 We seek curious, ethical, and driven professionals who want to use their skills 
//                 to create meaningful, lasting impact in education, health, climate resilience, 
//                 gender equality, youth empowerment, governance, social protection, and more.
//               </p>

//               <p>
//                 Whether you are an experienced researcher, M&E specialist, data analyst, 
//                 gender & inclusion expert, public policy professional, or early-career talent 
//                 passionate about evidence-based development — we would love to hear from you.
//               </p>
//             </div>

//             <div className="mission-visual">
//               <div className="icon-grid">
//                 <div className="icon-item">
//                   <Briefcase size={48} />
//                   <span>Research & Evaluation</span>
//                 </div>
//                 <div className="icon-item">
//                   <Globe size={48} />
//                   <span>Policy & Systems Thinking</span>
//                 </div>
//                 <div className="icon-item">
//                   <HeartHandshake size={48} />
//                   <span>Inclusion & Equity</span>
//                 </div>
//                 <div className="icon-item">
//                   <Users size={48} />
//                   <span>Capacity Building</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Inclusion Statement */}
//       <section className="section inclusion-section bg-light">
//         <div className="container text-center">
//           <h2>Our Commitment to Inclusion</h2>
//           <p className="inclusion-lead">
//             DevLearn Impact Research Ltd is an equal-opportunity organisation.<br />
//             We actively encourage applications from
//           </p>

//           <div className="inclusion-groups">
//             <div className="group-pill">Women</div>
//             <div className="group-pill">Young professionals</div>
//             <div className="group-pill">Persons with disabilities</div>
//             <div className="group-pill">Underrepresented groups</div>
//           </div>
//         </div>
//       </section>

//       {/* Associate Network */}
//       <section className="section associate-section">
//         <div className="container">
//           <div className="text-center">
//             <h2>Join Our Associate Consultant Network</h2>
//             <p className="lead">
//               We maintain a regional pool of Associate Consultants who are engaged periodically 
//               on research, training, evaluation, capacity development, and advisory assignments.
//             </p>
//           </div>

//           <div className="apply-box">
//             <h3>How to Apply</h3>
//             <p>
//               To express interest in working with DevLearn, please complete our short online 
//               application form and upload your CV together with a brief statement of interest 
//               (maximum 300 words).
//             </p>

//             <a
//               href="https://forms.gle/Pa4m51o2FMvoA7yw8"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="btn btn-primary large"
//             >
//               Submit Your Application <ArrowRight size={24} />
//             </a>

//             <p className="small-note">
//               We review expressions of interest on a rolling basis and will contact you when 
//               opportunities that match your profile become available.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="final-cta text-center">
//         <div className="container">
//           <h2>Ready to contribute to meaningful change?</h2>
//           <p>We look forward to learning about your experience and vision.</p>
//           <a
//             href="https://forms.gle/Pa4m51o2FMvoA7yw8"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="btn btn-primary large"
//           >
//             Apply Now <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Re-use the same footer as Team page */}
//       <footer className="footer">
//         <div className="footer-grid container">
//           <div>
//             <div className="footer-logo">DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/careers">Careers</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2026 DevLearn Impact Research Ltd. All rights reserved.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Careers;